/**
 * Shared Terms of Service content.
 *
 * Single source of truth for the 23 ToS sections — rendered by both the
 * blocking acceptance modal (TermsOfServiceModal) and the public
 * /terms page (TermsOfServicePage). The wrapper component controls
 * spacing/scroll/typography; this component emits semantic content only.
 */

import { useTranslation } from '../../hooks/useTranslation';

const TERMS_SECTIONS = [
  'platformTool',
  'eligibility',
  'userContent',
  'communications',
  'matureContent',
  'prohibitedContent',
  'copyright',
  'aiContent',
  'aiConfidentiality',
  'accountSecurity',
  'tokensPayments',
  'rewardsSystem',
  'dataPrivacy',
  'thirdParty',
  'serviceAvailability',
  'desktopDisclaimer',
  'liability',
  'indemnification',
  'termination',
  'regionalCompliance',
  'governmentOrders',
  'modifications',
  'governingLaw',
] as const;

export function TermsContent() {
  const { t } = useTranslation();

  return (
    <>
      {TERMS_SECTIONS.map((key) => (
        <section key={key}>
          <h3 className="section-heading-purple">{t(`tos.sections.${key}.title`)}</h3>
          <p className="text-sm text-white/70 leading-relaxed">
            {t(`tos.sections.${key}.content`)}
          </p>
        </section>
      ))}
    </>
  );
}
